import {
  Button as RNButton,
  Pressable,
  Platform,
  StyleSheet,
  Text,
  View,
  FlatList,
  NativeSyntheticEvent,
  NativeScrollEvent,
  useWindowDimensions,
  TouchableOpacity,
} from 'react-native';
import { FlashList, type FlashListRef } from '@shopify/flash-list';
import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useRef,
  useMemo,
} from 'react';
import ProductItem from './Product';
import FastImage from '@d11/react-native-fast-image';
import { useDispatch } from 'react-redux';
import searchContext from '../../../Context/SearchContext';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useAuth from '../../../hooks/useAuth';
import {
  addSearchProducts,
  updateSearchProducts,
  addupdateProducts,
  addProductsBySubCategory,
  updateProductsBySubCategory,
  seedProductsBySubCategoryFromDocs,
  seedSearchProductsFromLocal,
  ProductsObject,
  resetSearchProducts,
  SearchedProductsObject,
  selectSearchedProducts,
  selectProductsBySubCategory,
  selectProducts,
  selectSubCategories,
  clearProductsBySubCategory,
  selectProductsByTabKeyMap,
} from '../../../redux/productSlice';
import {
  getLocationEpoch,
  isCurrentLocationEpoch,
} from '../../../utils/locationEpoch';
import { ExtrasContext } from '../../../Context/ExtrasContext';
import AnimatedLottieView from 'lottie-react-native';
import ErrorContext from '../../../Context/ErrorContext';
import { useAppSelector } from '../../../redux/helper';
import {
  fs,
  s,
  v,
  dumpTokens,
  forceHttps,
  iconSize,
  borderWidth,
} from '../../../utils/libs';
import { getApiMessage } from '../../../utils/apiError';
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {
  getProducts,
  getSearchedProducts,
  getProductsBySubCategory as apiGetProductsBySubCategory,
} from '../../../api/products';
import { axiosPrivate } from '../../../axiosClient';
import Button from '../../../components/Reusables/Button';
import {
  ClearCart,
  clearCartOrderData,
  DecreaseCart,
  selectUpdatingCartItems,
  setUpdatingCartitems,
} from '../../../redux/cartSlice';
import { getTotals } from '../../../redux/cartSlice';
import { clearOrderDetails } from '../../../redux/orderDetailsSlice';
import Typography from '../../../components/Reusables/Typography';
import CustomBottomSheet from '../../../components/Reusables/bottomSheet/CustomBottomSheet';
import AppSkeleton from '../../../components/Reusables/AppSkeleton';
import { BottomSheetModal } from '@gorhom/bottom-sheet';
import DeviceInfo, { isTablet } from 'react-native-device-info';

import { PRODUCT_LIMIT } from '../../../CONSTANTS';
import { useNavigation as useNavigationContext } from '../../../Context/NavigationContext';
import { useTheme, palette, GTFonts, useLayoutSize } from '../../../theme';
import useLocation from '../../../hooks/useLocation';
import useFetchSubCategories from '../../../hooks/useFetchSubCategories';
import useKeyboardAwareListScroll from '../../../hooks/useKeyboardAwareListScroll';
import { showToast } from '../../../services/toast';
import MaterialCommunityIcons from '@react-native-vector-icons/material-design-icons/static';
import ProductDetailBottomSheet from '../../../components/ProductDetailBottomSheet';
import { useSelector, shallowEqual } from 'react-redux';
import {
  selectProductSort,
  ProductSortOption,
} from '../../../redux/productSortSlice';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withSpring,
} from 'react-native-reanimated';
import {
  SettingsDetails,
  selectShowProductImages,
  selectShowAlphaRail,
  selectQuantityButtons,
  selectUseGestureQuantity,
} from '../../../redux/SettingsSlice';
import { FEATURE_FLAGS, PRODUCT_LIST_SEARCH_LIMIT } from '../../../CONSTANTS';
import { AlphaRail, AlphaRailHandle } from './AlphaRail';
import {
  getEffectiveQuantity,
  getEffectiveSellingPrice,
  getPriceRangeDisplay,
  isVariantProduct,
} from '../../../utils/variantHelpers';

// Stable empty identity so the originalOrderIds selector returns the SAME
// reference outside edit mode. Prevents spurious re-renders / memo
// invalidation when Redux mutates unrelated cart state.
const EMPTY_IDS: string[] = [];

const throttle = (func: Function, limit: number) => {
  let inThrottle: boolean;
  return function (this: any, ...args: any[]) {
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), limit);
    }
  };
};

const ProductList = () => {
  const navigation = useNavigation();
  const isTablet = DeviceInfo.isTablet();
  const settings = useAppSelector(SettingsDetails);
  const showProductImages = useAppSelector(selectShowProductImages);
  const quantityButtons = useAppSelector(selectQuantityButtons);
  const useGestureQuantity = useAppSelector(selectUseGestureQuantity);
  const showAlphaRailPref = useAppSelector(selectShowAlphaRail);
  const { clearOrderDetailsData } = useNavigationContext();

  //@ts-ignore
  const route = useRoute();
  const lastProductBottomSheetModalRef = useRef<BottomSheetModal>(null as any);
  const productDetailBottomSheetRef = useRef<BottomSheetModal>(null as any);
  const subcategoryFlatListRef = useRef<FlashListRef<any>>(null);
  const subcategoryHeaderListRef = useRef<FlatList<string>>(null);
  const productsFlatlistRef = useRef<FlashListRef<any>>(null);
  const { handleError, resetSnackMessage } = useContext(ErrorContext);
  const { auth, setAuth } = useAuth();
  const dispatch = useDispatch();
  const axiosprivate = useAxiosPrivate();
  const { search } = useContext(searchContext);
  const { isRowLayout, networkAvailableGlobal } =
    useContext(ExtrasContext);
  const employeedata = useAppSelector(
    state => state.auth.inApp.account.employeeInfo,
  );

  const subcategories = useAppSelector(selectSubCategories);
  const searchedproducts = useAppSelector(selectSearchedProducts);
  const productsbysubcategory = useAppSelector(selectProductsBySubCategory);
  const { width, isPortrait } = useLayoutSize();
  const { isAdmin } = useLocation();
  const products = useAppSelector(selectProducts);
  const productsByTabKeyMap = useAppSelector(selectProductsByTabKeyMap);
  const fetchSubCategories = useFetchSubCategories();

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [categoryloading, setCategoryLoading] = useState(false);
  const [subcategory, setSubcategory] = useState('AllProducts');
  const [subcategorydata, setSubcategoryData] = useState(
    productsbysubcategory.docs ?? [],
  );
  const [allSubCategories, setAllSubCategories] = useState<string[]>([]);
  const [searchdata, setSearchData] = useState(searchedproducts.data ?? []);
  const [maindata, setMaindata] = useState(products.docs ?? []);
  const sortOption = useSelector(selectProductSort);
  const updatingCartitems = useAppSelector(selectUpdatingCartItems);
  // IDs of products that belong to the order currently being edited
  // ("Add more products" flow). Sourced from cartOrderData.order (snapshot
  // frozen for the edit session), NOT from cartItems, so tapping +/- on
  // products during the edit doesn't mutate this set — only the original
  // order's items stay pinned at the top.
  const originalOrderIds = useSelector((state: any) => {
    if (!state?.cart?.updatingCartitems) return EMPTY_IDS;
    const order = state?.cart?.cartOrderData?.order;
    if (!order?.length) return EMPTY_IDS;
    const ids: string[] = [];
    for (const o of order) {
      const id = o?.bp_product_information?._id;
      if (id) ids.push(id);
    }
    return ids.length ? ids : EMPTY_IDS;
  }, shallowEqual);
  // The A–Z rail is only meaningful when the list is actually sorted A→Z.
  // 'default' is legacy-persisted state that now maps to name_asc (see
  // productSortSlice), so both satisfy the alpha-sort condition.
  const isAlphaSort = sortOption === 'name_asc' || sortOption === 'default';
  const alphaRailEnabled =
    FEATURE_FLAGS.ALPHA_RAIL && showAlphaRailPref && isAlphaSort;
  const [searching, setSearching] = useState(false);
  // Scroll offsets are tracked in refs (not React state) because they are
  // written on every scroll tick. Holding them in state caused the whole
  // list tree to rerender continuously while scrolling — the root cause of
  // the observed jagged scroll and excessive child renders.
  const productsOffsetRef = useRef(0);
  const subCategoryProductsOffsetRef = useRef(0);
  // Guard against late async responses from previously selected subcategories.
  // Without this, stale updates can merge into `productsbysubcategory.docs` and show
  // "previous category" products after switching categories.
  const activeSubcategoryRef = useRef<string>(subcategory);
  const [tempProduct, setTempProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [subcategoryPickerOpen, setSubcategoryPickerOpen] = useState(false);
  // Active-letter state is NOT held here — it lives inside <AlphaRail /> and
  // is driven imperatively via alphaRailRef. This keeps scroll-driven
  // highlight changes from rerendering the list.
  const alphaRailRef = useRef<AlphaRailHandle>(null);
  const subcategoryPickerSheetRef = useRef<BottomSheetModal>(null as any);

  useEffect(() => {
    activeSubcategoryRef.current = subcategory;
  }, [subcategory]);

  useFocusEffect(
    useCallback(() => {
      const from = (route as any)?.params?.from as string | undefined;
      if (from) {
        setSubcategory('AllProducts');
        if (
          from === 'Checkout' ||
          from === 'NewProduct' ||
          from === 'OrderDetails'
        ) {
          // Small delay to ensure the list has rendered
          setTimeout(() => {
            // Since we set subcategory to 'AllProducts' above, use productsFlatlistRef
            productsFlatlistRef.current?.scrollToOffset({
              animated: true,
              offset: 0,
            });
          }, 150);
        }
      }
      return () => {
        resetSnackMessage();
      };
    }, [route]),
  );

  useEffect(() => {
    if (products?.docs?.length > 0) {
      setMaindata(products.docs);
    }
  }, [products?.docs]);

  useEffect(() => {
    if (subcategories) {
      const allSubCategories = ['AllProducts'];
      allSubCategories.push(...subcategories);
      setAllSubCategories(allSubCategories);
    }
  }, [subcategories]);

  useEffect(() => {
    if (searchedproducts?.data) {
      console.log('searchedproducts', searchedproducts);
      setSearchData(searchedproducts.data);
    }
  }, [searchedproducts]);

  const getAllproducts = useCallback(
    async (currentpage: number, limit: number): Promise<boolean> => {
      const epoch = getLocationEpoch();
      try {
        console.log('currentpage', currentpage);
        if (loading) return false;
        setLoading(true);
        try {
          const response = await getProducts(
            axiosprivate,
            currentpage,
            limit,
            auth,
          );
          if (!isCurrentLocationEpoch(epoch)) return false;
          if (response?.data?.status === 200) {
            dispatch(addupdateProducts(response?.data.data));
            return true;
          }
          if (response.data.message === 'Employee not found') {
            setAuth({ accessToken: '', refreshToken: '' });
            dumpTokens();
            return false;
          }
          handleError(response.data.message, 'error', true);
          return false;
        } catch (error: any) {
          if (!isCurrentLocationEpoch(epoch)) return false;
          handleError(getApiMessage(error), 'error', true);
          return false;
        } finally {
          setLoading(false);
        }
      } catch (error: any) {
        if (!isCurrentLocationEpoch(epoch)) return false;
        handleError(getApiMessage(error), 'error', true);
        return false;
      }
    },
    [loading, auth],
  );
  // const getAllSubCategories = useCallback(async () => {
  //   try {
  //     const response = await getSubCategories(axiosprivate, auth);
  //     if (response?.data?.status === 200) {
  //       dispatch(addSubCategories(response?.data?.data));
  //     } else if (response.data.message === "Employee not found") {
  //       setAuth({ accessToken: "", refreshToken: "" });
  //       try {
  //         await AsyncStorage.removeItem("refreshToken");
  //         return true;
  //       } catch (exception) {
  //         return false;
  //       }
  //     } else {
  //       console.log("error found");
  //       handleError(response.data.message, "error", true);
  //     }
  //   } catch (error) {
  //     console.log("getAllSubCategories", error);
  //     // handleError(error.message, "error", true);
  //   }
  // }, [auth, dispatch]);

  const getSearchedproducts = async (currentpage: number) => {
    console.log(currentpage);
    if (!loading) {
      setSearching(true);
      try {
        const response = await getSearchedProducts(
          axiosPrivate,
          search,
          currentpage,
          PRODUCT_LIST_SEARCH_LIMIT,
          auth,
        );
        console.log('getSearchedproducts', response.data);
        const searchedProductsObject: SearchedProductsObject =
          response?.data?.data;
        if (response?.data?.status === 200) {
          dispatch(updateSearchProducts(searchedProductsObject));
        } else {
          console.log('error found');
          handleError(response.data.message, 'error', true);
        }
      } catch (error: any) {
        console.log('getSearchedproductsError', error);
        handleError(getApiMessage(error), 'error', true);
      } finally {
        setSearching(false);
      }
    } else return;
  };

  const throttledGetSearchedproducts = throttle(getSearchedproducts, 300);

  const handleSearchChange = (page: number) => {
    throttledGetSearchedproducts(page);
  };

  useEffect(() => {
    console.log(search);
    const term = search?.trim() || '';
    if (term.length > 1) {
      // Local-first seed for instant UX
      dispatch(seedSearchProductsFromLocal(term));
      // Background backend merge (throttled)
      handleSearchChange(1);
    } else if (term.length < 1) {
      dispatch(resetSearchProducts());
      setSearchData([]);
    }
  }, [search]);

  const getProductsBySubCategory = useCallback(
    async (currentpage: number, subcategory?: string): Promise<boolean> => {
      const requestedSubcategory = String(subcategory || '');
      // Guard: Don't call API for 'AllProducts'
      if (!requestedSubcategory || requestedSubcategory === 'AllProducts') {
        console.log('Skipping API call for AllProducts subcategory');
        return false;
      }
      const limit = 20;
      const epoch = getLocationEpoch();
      if (currentpage === 1) setCategoryLoading(true);
      try {
        const response = await apiGetProductsBySubCategory(
          axiosprivate,
          requestedSubcategory,
          currentpage,
          limit,
          auth,
        );
        if (!isCurrentLocationEpoch(epoch)) return false;
        // If the user switched categories while this request was in-flight,
        // ignore the stale response to avoid mixing categories.
        if (activeSubcategoryRef.current !== requestedSubcategory) return false;
        if (response?.data?.status === 200) {
          console.log('products by subcategory', response?.data);
          // const subcatproductsObject: ProductsObject = response?.data?.data;
          // if (subcatproductsObject.page === 1) {
          //   dispatch(addProductsBySubCategory(response?.data.data));
          // } else {
          dispatch(updateProductsBySubCategory(response?.data.data));
           // }
          return true;
        }
        handleError(response.data.message, 'error', true);
        return false;
      } catch (error: any) {
        console.log(error);
        handleError(getApiMessage(error), 'error', true);
        return false;
      } finally {
        if (
          currentpage === 1 &&
          activeSubcategoryRef.current === requestedSubcategory
        ) {
          setCategoryLoading(false);
        }
      }
    },
    [dispatch, auth, axiosprivate, handleError],
  );

  const fetchProductsBySubCategory = useCallback(
    async (subcategory: string) => {
      setSubcategory(subcategory);
      if (subcategory && subcategory !== 'AllProducts') {
        setCategoryLoading(true);
        dispatch(clearProductsBySubCategory());
        const key = String(subcategory || '').trim();
        const seededDocs = productsByTabKeyMap.get(key) ?? [];
        dispatch(seedProductsBySubCategoryFromDocs(seededDocs));
        // Background fetch to merge latest figures and new items
        void getProductsBySubCategory(1, subcategory);
      }
    },
    [dispatch, getProductsBySubCategory, productsByTabKeyMap],
  );

  useEffect(() => {
    if (subcategory && subcategory !== 'AllProducts') {
      setSubcategoryData(productsbysubcategory.docs);
      subcategoryFlatListRef.current?.scrollToOffset({
        animated: false,
        offset: subCategoryProductsOffsetRef.current,
      });
    }
    //not repetition
    else if (subcategory && subcategory === 'AllProducts') {
      // setMaindata(products.docs);
      productsFlatlistRef.current?.scrollToOffset({
        animated: false,
        offset: productsOffsetRef.current,
      });
    }
  }, [subcategory, products, productsbysubcategory]);

  const loadMoreProducts = useCallback(() => {
    if (products.hasNextPage && products.nextPage) {
      getAllproducts(products.nextPage, PRODUCT_LIMIT);
    }
  }, [products.hasNextPage, products.nextPage, getAllproducts]);

  const loadMoreSearchResults = useCallback(() => {
    const term = search?.trim() || '';
    if (
      term.length > 0 &&
      searchedproducts.hasNextPage &&
      searchedproducts.nextPage
    ) {
      getSearchedproducts(searchedproducts.nextPage);
    }
  }, [searchedproducts, search]);
  const loadMoreProductsFromSubCategory = useCallback(() => {
    if (
      subcategory &&
      subcategory !== 'AllProducts' &&
      productsbysubcategory.hasNextPage &&
      productsbysubcategory.nextPage
    ) {
      getProductsBySubCategory(productsbysubcategory.nextPage, subcategory);
    }
  }, [
    subcategory,
    productsbysubcategory.hasNextPage,
    productsbysubcategory.nextPage,
    getProductsBySubCategory,
  ]);
  const refetchProductData = useCallback(async (): Promise<boolean> => {
    const [subcategoriesOk, productsOk] = await Promise.all([
      fetchSubCategories(),
      subcategory === 'AllProducts'
        ? getAllproducts(1, PRODUCT_LIMIT)
        : getProductsBySubCategory(1, subcategory),
    ]);
    return subcategoriesOk && productsOk;
  }, [
    dispatch,
    auth,
    axiosprivate,
    subcategory,
    fetchSubCategories,
    getAllproducts,
    getProductsBySubCategory,
  ]);

  const Refresh = useCallback(async () => {
    setRefresh(true);
    try {
      const ok = await refetchProductData();
      if (ok) {
        showToast('Products refreshed', 'success');
      }
    } finally {
      setRefresh(false);
    }
  }, [refetchProductData]);

  useEffect(() => {
    if (!loading && !searching && !categoryloading) {
      if (products.docs.length === 0) {
        subcategory === 'AllProducts'
          ? getAllproducts(1, PRODUCT_LIMIT)
          : getProductsBySubCategory(1, subcategory);
      }
    }
  }, []);

  // Write to refs — never setState — so scroll events stay render-free.
  const handleScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      productsOffsetRef.current = event.nativeEvent.contentOffset.y;
    },
    [],
  );

  const handleSubCategoryScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      subCategoryProductsOffsetRef.current = event.nativeEvent.contentOffset.y;
    },
    [],
  );

  // Released by onMomentumScrollEnd / onScrollEndDrag below.
  const handleAlphaRailUnlock = useCallback(() => {
    alphaRailRef.current?.unlock();
  }, []);

  const handleSubproductQuantity = useCallback(
    (product: any) => {
      dispatch(DecreaseCart(product));
      dispatch(getTotals());
    },
    [dispatch],
  );

  const showbottomSheetFn = useCallback(
    (product: any) => {
      if (settings?.showIncompleteOrderPopup !== false) {
        lastProductBottomSheetModalRef.current?.present();
        setTempProduct(product);
      } else {
        setTempProduct(product);
      }
    },
    [settings?.showIncompleteOrderPopup],
  );

  const handleProductPress = useCallback((product: any) => {
    setSelectedProduct(product);
    console.log('selected-product', product);
    // Use requestAnimationFrame to ensure the state update has been processed
    requestAnimationFrame(() => {
      productDetailBottomSheetRef.current?.present();
    });
  }, []);

  // Resolves the list that is currently rendered. Reads the active
  // subcategory from a ref so the identity stays stable — cards would
  // otherwise all re-render when the user changes tab.
  const getKeyboardScrollTarget = useCallback(() => {
    const isSubcategoryList =
      !!activeSubcategoryRef.current &&
      activeSubcategoryRef.current !== 'AllProducts';
    return isSubcategoryList
      ? {
          key: 'subcategory',
          listRef: subcategoryFlatListRef,
          offsetRef: subCategoryProductsOffsetRef,
        }
      : {
          key: 'all',
          listRef: productsFlatlistRef,
          offsetRef: productsOffsetRef,
        };
  }, []);

  // Lifts a focused product card above the on-screen keyboard, and only by as
  // much as the keyboard actually covers it.
  const {
    onInputFocus: handleCardInputFocus,
    onScrollBeginDrag: handleKeyboardScrollBeginDrag,
  } = useKeyboardAwareListScroll(getKeyboardScrollTarget);

  // Stable handler for the "missing image" CTA on each product card.
  // Hoisted out of renderItem so React.memo on ProductItem isn't defeated by
  // a fresh function identity on every parent render. The callback arg `p`
  // already carries `productID` (see memoizedProduct in Product.tsx), so no
  // closure over the per-row product is needed.
  const handleMissingImagePress = useCallback(
    (p: any) => {
      (navigation as any).navigate('EmployeeAddProductImage', {
        productId: p?.productID,
      });
    },
    [navigation],
  );

  const closeModal = useCallback(() => {
    lastProductBottomSheetModalRef.current?.dismiss();
  }, []);

  const clearCart = useCallback(() => {
    handleSubproductQuantity(tempProduct);
    dispatch(ClearCart());
    dispatch(clearCartOrderData());
    dispatch(setUpdatingCartitems(false));
    dispatch(clearOrderDetails());
    closeModal();
    clearOrderDetailsData();
  }, [dispatch, tempProduct]);

  // Memoize item width calculation to prevent recalculation on every render
  const numColumns = useMemo(() => {
    if (isRowLayout) {
      // row layout unchanged: 1 on phone, 2 on wide
      return isTablet || Platform.OS === 'web' ? 2 : 1;
    }

    // native
    if (isTablet) {
      // tablet portrait ≈ phone density; tablet landscape gets 4
      return isPortrait ? 3 : 4;
    }
    return 2; // phone
  }, [isTablet, isRowLayout, isPortrait, width]);

  const itemWidth = useMemo(
    () => (numColumns === 1 ? '100%' : `${100 / numColumns}%`),
    [numColumns],
  );

  // Preload product images for visible + upcoming items

  const renderItem = useCallback(
    ({ item: product, index }: { item: any; index: number }) => {
      const hasVariants = isVariantProduct(product);
      const variantCount = Array.isArray(product?.bp_product_variants)
        ? product.bp_product_variants.length
        : 0;
      const effectivePrice = getEffectiveSellingPrice(product) ?? 0;
      const effectiveQuantity = getEffectiveQuantity(product);
      const priceRangeText = hasVariants ? getPriceRangeDisplay(product) : undefined;
      return (
        <View
          style={[
            // Ensure equal-width columns on RN Web by forcing each cell to flex
            // and moving horizontal spacing to the cell wrapper (not the card).
            numColumns > 1 && {
              flex: 1,
              flexBasis: 0,
              paddingHorizontal: s(4),
            },
          ]}>
          <ProductItem
            showbottomSheetFn={showbottomSheetFn}
            handleSubproductQuantity={handleSubproductQuantity}
            category={product.bp_product_category}
            itemname={product.bp_product_name}
            price={effectivePrice}
            quantity={effectiveQuantity}
            mass={product.bp_product_mass}
            unitofmass={product.bp_product_unit_of_mass}
            productID={product._id}
            hasVariants={hasVariants}
            variantCount={variantCount}
            variants={product.bp_product_variants ?? []}
            variantAttributes={product.bp_product_variant_attributes ?? []}
            priceRangeText={priceRangeText}
            model={product.bp_product_model}
            size={product.bp_product_size}
            msl={product?.bp_minimum_stock_level}
            price_type={product.bp_product_price_type}
            index={index}
            image={product.bp_product_image}
            isFavourite={product.bp_product_is_favourite}
            onProductPress={handleProductPress}
            // numColumns={numColumns}
            onMissingImagePress={handleMissingImagePress}
            onCardInputFocus={handleCardInputFocus}
            showProductImages={showProductImages}
            quantityButtons={quantityButtons}
            useGestureQuantity={useGestureQuantity}
            isRowLayout={isRowLayout}
          />
        </View>
      );
    },
    [
      isTablet,
      isRowLayout,
      itemWidth,
      numColumns,
      showbottomSheetFn,
      handleSubproductQuantity,
      handleProductPress,
      handleMissingImagePress,
      handleCardInputFocus,
      showProductImages,
      quantityButtons,
      useGestureQuantity,
    ],
  );

  // Preload product images for visible + upcoming items (moved after currentData definition below)

  const navigateToNewProduct = async () => {
    navigation.navigate('NewProduct' as never);
  };

  const render = ({ item: item }: { item: string }) => {
    const tabLabel = item === 'AllProducts' ? 'All Products' : item;
    return (
      <SubcategoryTab
        isActive={subcategory === item}
        label={tabLabel}
        onPress={() => fetchProductsBySubCategory(item)}
        styles={styles}
      />
    );
  };

  const handleSheetChanges = (index: number) => {
    console.log('handleSheetChanges', index);
  };

  const keytopExtractor = (item: any, i: number) => item + i.toString();

  const keyExtractor = (item: any) => item._id;

  const { theme } = useTheme();
  const styles = createStyles(theme);

  // Memoize data selection to prevent unnecessary recalculations
  const currentData = useMemo(() => {
    const base =
      search?.length > 1
        ? searchdata
        : subcategory !== 'AllProducts'
          ? subcategorydata
          : maindata;

    // local client-side sorting until backend endpoint supports it
    const sorted = [...base];
    switch (sortOption as ProductSortOption) {
      // 'default' is legacy; it maps to A–Z so existing installs pick up the
      // new canonical sort without requiring a manual toggle.
      case 'default':
      case 'name_asc':
        sorted.sort((a: any, b: any) =>
          String(a.bp_product_name).localeCompare(String(b.bp_product_name)),
        );
        break;
      case 'price_desc':
        sorted.sort(
          (a: any, b: any) =>
            (b.bp_product_selling_price ?? 0) -
            (a.bp_product_selling_price ?? 0),
        );
        break;
      case 'recent':
        // speculative: assume newer ids imply recent or backend later will provide; keep as-is for now
        sorted.sort((a: any, b: any) =>
          String(b._id).localeCompare(String(a._id)),
        );
        break;
      case 'in_stock':
        sorted.sort(
          (a: any, b: any) =>
            getEffectiveQuantity(b) - getEffectiveQuantity(a),
        );
        break;
      // Unknown / unhandled sort: leave insertion order.
    }

    // Pin ONLY products from the original order snapshot (the "Add more
    // products" edit flow). New adds via the +/- buttons are NOT in
    // originalOrderIds, so they stay in their sort position and don't hoist.
    if (originalOrderIds.length === 0) return sorted;
    const pinnedSet = new Set(originalOrderIds);
    const pinned: any[] = [];
    const rest: any[] = [];
    for (const p of sorted) {
      if (pinnedSet.has(p._id)) pinned.push(p);
      else rest.push(p);
    }
    return pinned.length ? [...pinned, ...rest] : sorted;
  }, [
    search,
    searchdata,
    subcategory,
    subcategorydata,
    maindata,
    sortOption,
    originalOrderIds,
  ]);

  const isInitialLoading =
    (loading || searching || categoryloading) && currentData.length === 0;
  const isLoadingMore =
    (loading || searching || categoryloading) && currentData.length > 0;

  const renderFooter = useCallback(() => {
    if (isInitialLoading) return null;
    if (isLoadingMore) {
      return (
        <View style={styles.skeletonFooter}>
          <AppSkeleton
            mode="product_catalog"
            count={Math.max(2, numColumns * 2)}
            numColumns={numColumns}
            isRowLayout={isRowLayout}
            showProductImages={showProductImages}
          />
        </View>
      );
    }

    const term = (search ?? '').trim();
    const isSearchMode = term.length > 1;
    const isSubcategoryMode = !isSearchMode && subcategory !== 'AllProducts';

    const inventoryEmpty = (maindata?.length ?? 0) === 0;
    const viewEmpty = currentData.length <= 0;

    const noSearchResults = isSearchMode && viewEmpty && !inventoryEmpty;
    const subcategoryEmpty = isSubcategoryMode && viewEmpty && !inventoryEmpty;

    if (viewEmpty && isAdmin) {
      const title = noSearchResults
        ? `No results for "${term}"`
        : subcategoryEmpty
          ? `No products in "${subcategory}"`
          : 'No products yet';

      const subtitle = noSearchResults
        ? 'Not found in inventory. Create it as a new product?'
        : subcategoryEmpty
          ? 'This category is empty. Add a product to this category.'
          : 'Add products to get started';

      const ctaText = noSearchResults ? `Add "${term}"` : 'Add Products';

      return (
        <View style={{ alignItems: 'center', gap: 30, marginTop: 20 }}>
          <Text
            style={{
              fontFamily: GTFonts.regular,
              lineHeight: 20,
              fontSize: isTablet ? 20 : 18,
            }}>
            {title}
          </Text>
          <Text
            style={{
              fontFamily: GTFonts.regular,
              lineHeight: 20,
              fontSize: isTablet ? 16 : 14,
              color: theme.colors.textSecondary,
              textAlign: 'center',
              marginHorizontal: s(16),
            }}>
            {subtitle}
          </Text>
          {
            <Button
              backgroundColor={theme.colors.successEmerald}
              rippleColor={theme.colors.successEmerald}
              text={ctaText}
              fontFamily={GTFonts.semibold}
              icon="plus"
              height={44}
              paddingHorizontal={44}
              borderRadius={5}
              onPress={navigateToNewProduct}
            />
          }
        </View>
      );
    }

    if (isAdmin && !viewEmpty) {
      const footerWidth = isTablet ? (isRowLayout ? '100%' : itemWidth) : '97%';
      return (
        <View style={styles.footerAddCardWrapper}>
          {/* @ts-expect-error */}
          <View style={{ width: footerWidth }}>
            <Pressable onPress={navigateToNewProduct}>
              <View style={styles.addCard}>
                <MaterialCommunityIcons
                  name="plus-box-outline"
                  size={iconSize(26)}
                  color={theme.colors.primary}
                  style={{ marginBottom: v(6) }}
                />
                <Text style={styles.addCardTitle}>Add More Products</Text>
                <Text style={styles.addCardSubtitle}>
                  Create a new product
                </Text>
              </View>
            </Pressable>
          </View>
        </View>
      );
    }

    if (viewEmpty && !isAdmin) {
      const subtitle = noSearchResults
        ? 'Try a different search term'
        : subcategoryEmpty
          ? `No products in "${subcategory}"`
          : 'Products will appear here';
      return (
        <View style={{ alignItems: 'center', gap: 20, marginTop: 100 }}>
          <Text>No products found</Text>
          <Text style={{ color: theme.colors.textSecondary }}>{subtitle}</Text>
        </View>
      );
    }
    return null;
  }, [
    isInitialLoading,
    isLoadingMore,
    currentData,
    isAdmin,
    search,
    subcategory,
    maindata,
    employeedata,
    isTablet,
    theme.colors,
    numColumns,
    isRowLayout,
    showProductImages,
    styles.footerAddCardWrapper,
    styles.addCard,
    styles.addCardTitle,
    styles.addCardSubtitle,
    itemWidth,
    navigateToNewProduct,
    styles.skeletonFooter,
  ]);

  // Preload product images for visible + upcoming items (now safely after currentData)
  const viewabilityConfig = useRef({ itemVisiblePercentThreshold: 60 }).current;
  const currentDataRef = useRef(currentData);
  useEffect(() => {
    currentDataRef.current = currentData;
  }, [currentData]);

  // Refs consumed by the stable onViewableItemsChanged callback below.
  // FlashList captures this callback once at mount and refuses updates, so any
  // reactive value (feature flag, current active letter) must be read via a
  // ref or call-time closure over React's stable setState.
  const alphaRailEnabledRef = useRef(alphaRailEnabled);
  useEffect(() => {
    alphaRailEnabledRef.current = alphaRailEnabled;
  }, [alphaRailEnabled]);

  // Same rationale: dominant-letter tracking inside onViewableItemsChanged
  // needs the current pinned-ids list without rebuilding the callback.
  const originalOrderIdsRef = useRef<string[]>(originalOrderIds);
  useEffect(() => {
    originalOrderIdsRef.current = originalOrderIds;
  }, [originalOrderIds]);

  // IMPORTANT: FlashList does NOT support changing this callback after mount.
  // Keep the function identity stable and read latest data from a ref.
  const onViewableItemsChanged = useRef(({ viewableItems }: any) => {
    try {
      if (!Array.isArray(viewableItems) || viewableItems.length === 0) return;
      const data = currentDataRef.current ?? [];
      const firstIndex = viewableItems[0]?.index ?? 0;
      const start = Math.max(0, firstIndex);
      const end = Math.min(data.length, start + 40);
      const toPreload = data.slice(start, end);
      const sources = toPreload
        .map((p: any) => String(p?.bp_product_image || ''))
        .filter(u => !!u)
        .map(uri => ({
          uri: forceHttps(uri),
          priority: FastImage.priority.high,
        }));
      if (sources.length) FastImage.preload(sources as any);

      // Dominant-letter highlight: tally first-letter buckets across items
      // currently in view and mark the bucket with the most items as active.
      // Alphabetical tiebreak keeps things stable when counts are equal.
      if (!alphaRailEnabledRef.current) return;
      const counts: Record<string, number> = {};
      const pinnedIds = originalOrderIdsRef.current;
      // Tiny array (orders are O(items-in-order)); build a Set once per
      // call rather than paying O(n) per item.
      const pinnedSet = pinnedIds.length ? new Set(pinnedIds) : null;
      for (const vi of viewableItems) {
        const product = vi?.item;
        if (!product) continue;
        let key: string;
        if (pinnedSet?.has(product._id)) {
          // Pinned original-order items vote for '#' so the rail highlights
          // '#' while the pinned block is in view, matching where they
          // actually live in the letter index.
          key = '#';
        } else {
          const raw = String(product?.bp_product_name || ' ')
            .trim()
            .charAt(0)
            .toLocaleUpperCase();
          key = /[A-Z]/.test(raw) ? raw : '#';
        }
        counts[key] = (counts[key] || 0) + 1;
      }
      const bucketKeys = Object.keys(counts).sort((a, b) => a.localeCompare(b));
      let best = '';
      let bestCount = -1;
      for (const k of bucketKeys) {
        if (counts[k] > bestCount) {
          bestCount = counts[k];
          best = k;
        }
      }
      // Hand the result to <AlphaRail /> imperatively. The rail itself
      // rAF-throttles and no-ops when locked — so tap-jumps don't flash
      // intermediate letters, and bursts of scroll ticks coalesce to one
      // frame-synced commit without rerendering this list.
      if (best) alphaRailRef.current?.setDominant(best);
    } catch { }
  }).current;

  useEffect(() => {
    const initial = currentData.slice(0, 60);
    const sources = initial
      .map((p: any) => String(p?.bp_product_image || ''))
      .filter(u => !!u)
      .map(uri => ({
        uri: forceHttps(uri),
        priority: FastImage.priority.high,
      }));
    if (sources.length) FastImage.preload(sources as any);
  }, [currentData]);

  // A–Z rail data (country-picker style): one pass, first-index-per-letter.
  // Always computed off currentData so the rail works on default + A–Z sorts.
  // Skipped entirely when the feature is off to avoid the O(n) scan.
  const { letters, letterIndex } = useMemo(() => {
    if (
      !alphaRailEnabled ||
      !Array.isArray(currentData) ||
      currentData.length === 0
    ) {
      return {
        letters: [] as string[],
        letterIndex: {} as Record<string, number>,
      };
    }
    const idx: Record<string, number> = {};
    // Pinned original-order products are forced into the '#' bucket so the
    // rail's 'A' jumps to the real A-block instead of a pinned 'Apple' at
    // index 0 (pinned block always lives at the head of currentData).
    const pinnedSet =
      originalOrderIds.length > 0 ? new Set(originalOrderIds) : null;
    for (let i = 0; i < currentData.length; i++) {
      const p = currentData[i];
      let key: string;
      if (pinnedSet?.has(p?._id)) {
        key = '#';
      } else {
        const raw = String(p?.bp_product_name || ' ')
          .trim()
          .charAt(0)
          .toLocaleUpperCase();
        key = /[A-Z]/.test(raw) ? raw : '#';
      }
      if (!(key in idx)) idx[key] = i;
    }
    const keys = Object.keys(idx).sort((a, b) => a.localeCompare(b));
    return { letters: keys, letterIndex: idx };
  }, [currentData, alphaRailEnabled, originalOrderIds]);

  const scrollToLetter = useCallback(
    (letter: string) => {
      const firstIdx = letterIndex[letter];
      if (firstIdx == null) return;
      const listRef =
        subcategory !== 'AllProducts'
          ? subcategoryFlatListRef
          : productsFlatlistRef;
      // Pin the rail to the tapped letter BEFORE kicking off the scroll.
      // While pinned, setDominant is ignored, so passing-through letters
      // cannot flash highlighted during the jump. The pin is
      // released when the list comes to rest (onMomentumScrollEnd /
      // onScrollEndDrag), at which point natural dominant tracking resumes.
      alphaRailRef.current?.lock(letter);
      // FlashList v2 scrollToIndex uses the data-array index (each product is one
      // item even with numColumns > 1). FlatList used a row index — do not divide.
      void listRef.current?.scrollToIndex({
        index: firstIdx,
        animated: true,
        viewPosition: 0,
      });
    },
    [letterIndex, subcategory],
  );

  // Memoize onEndReached handler to prevent recreating on every render
  const onEndReachedHandler = useMemo(() => {
    const term = search?.trim() || '';
    return term.length > 0
      ? loadMoreSearchResults
      : subcategory !== 'AllProducts'
        ? loadMoreProductsFromSubCategory
        : loadMoreProducts;
  }, [
    search,
    subcategory,
    loadMoreProductsFromSubCategory,
    loadMoreProducts,
    loadMoreSearchResults,
  ]);

  // Present/dismiss subcategory picker sheet
  useEffect(() => {
    if (subcategoryPickerOpen) {
      subcategoryPickerSheetRef.current?.present();
    } else {
      subcategoryPickerSheetRef.current?.dismiss();
    }
  }, [subcategoryPickerOpen]);

  const handlePickSubcategory = useCallback(
    (name: string) => {
      setSubcategoryPickerOpen(false);
      // Scroll the header horizontal list to the picked subcategory
      const index = allSubCategories.findIndex(s => s === name);
      if (index >= 0) {
        try {
          subcategoryHeaderListRef.current?.scrollToIndex({
            index,
            animated: true,
            viewPosition: 0.5,
          });
        } catch (e) {
          // fallback handled by onScrollToIndexFailed
        }
      }
      // Trigger same behavior as tapping the horizontal chip (local seed first)
      fetchProductsBySubCategory(name);
    },
    [allSubCategories, fetchProductsBySubCategory],
  );

  const renderPickerItem = useCallback(
    ({ item: name }: { item: string }) => {
      const isActive = name === subcategory;
      return (
        <Pressable
          onPress={() => handlePickSubcategory(name)}
          style={[
            styles.pickerRadioItem,
            isActive && styles.pickerRadioItemActive,
          ]}>
          <MaterialCommunityIcons
            name={isActive ? 'radiobox-marked' : 'radiobox-blank'}
            size={iconSize(20)}
            color={isActive ? theme.colors.success : theme.colors.text}
          />
          <Typography
            style={[
              styles.pickerRadioLabel,
              isActive && styles.pickerRadioLabelActive,
            ]}>
            {name}
          </Typography>
        </Pressable>
      );
    },
    [
      handlePickSubcategory,
      subcategory,
      theme.colors.success,
      theme.colors.text,
      styles,
    ],
  );

  const SubcategoryTab = ({
    isActive,
    label,
    onPress,
    styles,
  }: {
    isActive: boolean;
    label: string;
    onPress: () => void;
    styles: ReturnType<typeof createStyles>;
  }) => {
    const scale = useSharedValue(1);

    const animatedStyle = useAnimatedStyle(() => ({
      transform: [{ scale: scale.value }],
    }));

    const handlePress = useCallback(() => {
      // natural-feeling bounce
      scale.value = withSequence(
        withSpring(0.98, { damping: 12, stiffness: 220, mass: 0.9 }),
        withSpring(1, { damping: 10, stiffness: 200, mass: 0.9 }),
      );
      onPress();
    }, [onPress]);

    return (
      <Pressable
        onPress={handlePress}
        hitSlop={5}
        style={styles.Subcategorycontainer}>
        <Animated.View style={animatedStyle}>
          <View
            style={isActive ? styles.subCategoryPressed : styles.subCategory}>
            <Text style={isActive ? styles.textPressed : styles.text}>
              {label}
            </Text>
          </View>
        </Animated.View>
      </Pressable>
    );
  };

  return (
    <View style={{ flex: 1 }}>
      <>
        <View style={styles.subCategoryBarRow}>
          {allSubCategories.length > 1 ? (
            <TouchableOpacity
              onPress={() => setSubcategoryPickerOpen(true)}
              style={styles.subCategoryMoreOuter}
              hitSlop={{ top: v(6), bottom: v(6), left: s(4), right: s(4) }}
              accessibilityRole="button"
              accessibilityLabel="More subcategories">
              <View style={styles.subCategoryIconWrapper}>
                <MaterialCommunityIcons
                  name="format-list-bulleted"
                  size={iconSize(22)}
                  color={theme.colors.primaryDark}
                />
              </View>
            </TouchableOpacity>
          ) : null}
          <FlatList
            style={styles.subCategoryHeaderList}
            ref={subcategoryHeaderListRef}
            data={allSubCategories}
            renderItem={render}
            horizontal={true}
            keyExtractor={keytopExtractor}
            contentContainerStyle={styles.subCategoryHeaderListContent}
            showsHorizontalScrollIndicator={true}
            onScrollToIndexFailed={info => {
              subcategoryHeaderListRef.current?.scrollToOffset({
                offset: Math.max(0, info.averageItemLength * info.index),
                animated: false,
              });
              setTimeout(() => {
                subcategoryHeaderListRef.current?.scrollToIndex({
                  index: Math.min(info.index, allSubCategories.length - 1),
                  animated: true,
                  viewPosition: 0.5,
                });
              }, 0);
            }}
          />
        </View>

        <View style={styles.productsArea}>
          <FlashList
            ref={
              subcategory !== 'AllProducts'
                ? subcategoryFlatListRef
                : productsFlatlistRef
            }
            keyExtractor={keyExtractor}
            onScroll={
              subcategory !== 'AllProducts'
                ? handleSubCategoryScroll
                : handleScroll
            }
            data={currentData}
            renderItem={renderItem}
            automaticallyAdjustKeyboardInsets
            style={{ flex: 1 }}
            contentContainerStyle={styles.flatListContent}
            numColumns={numColumns}
            key={numColumns}
            drawDistance={Platform.OS === 'web' ? undefined : 400}
            onEndReachedThreshold={0.6}
            bounces={true}
            onEndReached={onEndReachedHandler}
            onViewableItemsChanged={onViewableItemsChanged}
            viewabilityConfig={viewabilityConfig}
            refreshing={refresh}
            onRefresh={Refresh}
            showsVerticalScrollIndicator={!alphaRailEnabled}
            onMomentumScrollEnd={handleAlphaRailUnlock}
            onScrollBeginDrag={handleKeyboardScrollBeginDrag}
            onScrollEndDrag={handleAlphaRailUnlock}
            ListEmptyComponent={
              isInitialLoading ? (
                <View style={styles.skeletonEmpty}>
                  <AppSkeleton
                    mode="product_catalog"
                    count={12}
                    numColumns={numColumns}
                    isRowLayout={isRowLayout}
                    showProductImages={showProductImages}
                  />
                </View>
              ) : null
            }
            ListFooterComponent={renderFooter}
          />

          {/* Alpha-numeric index rail — visible when the feature is
              enabled (dev flag + user pref) and data exists. Owns its own
              active-letter state; parent writes to it via alphaRailRef. */}
          {alphaRailEnabled && letters.length > 0 ? (
            <AlphaRail
              ref={alphaRailRef}
              letters={letters}
              onLetterPress={scrollToLetter}
            />
          ) : null}
        </View>
      </>
      {/* {(categoryloading || loading) && (
        <Indicator isloading={categoryloading || loading} />
      )} */}
      <CustomBottomSheet
        bottomSheetModalRef={lastProductBottomSheetModalRef}
        snapPoints={['40%']}
        enableDynamicSizing={false}
        handleSheetChanges={handleSheetChanges}
        constrainWidth
        header={
          <Typography style={styles.bottomSheetTitle}>Clear Basket?</Typography>
        }
        footer={
          <View
            style={{
              flexDirection: 'column',
              gap: 15,
              marginTop: v(15),
            }}>
            <Button
              backgroundColor={theme.colors.error}
              rippleColor={theme.colors.errorRipple}
              text="Clear Basket"
              fullWidth
              icon=""
              paddingHorizontal={44}
              borderRadius={s(8)}
              height={44}
              fontSize={fs(14)}
              onPress={clearCart}
            />
            <Button
              backgroundColor={theme.colors.success}
              rippleColor={theme.colors.primary}
              text="No, Continue With Order"
              icon=""
              fullWidth
              height={44}
              paddingHorizontal={44}
              borderRadius={s(8)}
              fontSize={fs(14)}
              onPress={closeModal}
            />
          </View>
        }>
        <View style={styles.bottomSheet}>
          <Typography style={styles.bottomSheetinfoText}>
            Hi {employeedata?.bp_employee_name}, Since this order is not
            completed, it will be automatically saved. To process another order,
            please clear the basket.
          </Typography>
        </View>
      </CustomBottomSheet>
      <CustomBottomSheet
        bottomSheetModalRef={subcategoryPickerSheetRef}
        snapPoints={['85%']}
        enableDynamicSizing={false}
        handleSheetChanges={index => {
          if (index === -1) setSubcategoryPickerOpen(false);
        }}
        constrainWidth
        header={
          <Typography style={styles.bottomSheetTitle}>
            Select Category
          </Typography>
        }>
        <View style={styles.bottomSheet}>
          <FlatList
            data={allSubCategories}
            keyExtractor={keytopExtractor}
            renderItem={renderPickerItem}
            numColumns={2}
            columnWrapperStyle={styles.pickerRow}
            contentContainerStyle={styles.pickerListContent}
            showsHorizontalScrollIndicator={false}
          />
        </View>
      </CustomBottomSheet>
      <ProductDetailBottomSheet
        bottomSheetRef={productDetailBottomSheetRef}
        product={selectedProduct}
        handleSubproductQuantity={handleSubproductQuantity}
      />
    </View>
  );
};

export default ProductList;

// Create themed styles function
const createStyles = (theme: any) =>
  StyleSheet.create({
    flatListContent: {
      flexGrow: 1,
      paddingBottom: s(200), //needs large padding bottom to prevent keyboard from covering the products
      paddingTop: v(2),
      backgroundColor: theme.colors.background,
    },
    productlist: {
      flex: 1,
      height: '100%',
      justifyContent: 'center',
      position: 'relative',
      backgroundColor: theme.colors.background,
    },
    subCategoryBarRow: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.primaryDark,
    },
    subCategoryMoreOuter: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: s(4),
      paddingRight: s(6),
      paddingVertical: v(8),
    },
    subCategoryHeaderList: {
      flex: 1,
      minWidth: 0,
    },
    subCategoryHeaderListContent: {
      alignItems: 'center',
      paddingRight: s(12),
      backgroundColor: theme.colors.primaryDark,
    },
    Subcategorycontainer: {
      flexDirection: 'row',
      paddingVertical: v(8),
      backgroundColor: theme.colors.primaryDark,
    },
    row: {
      flex: 1,
      justifyContent: 'space-around',
    },
    /** Inactive: text on bar (reference: white label, no chip). */
    subCategory: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: s(isTablet() ? 6 : 8),
      paddingHorizontal: s(6),
      // marginHorizontal: s(2),
      backgroundColor: 'transparent',
    },
    /** Active: white pill + bar blue text (reference). */
    subCategoryPressed: {
      borderRadius: theme.borderRadius.md,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: s(isTablet() ? 6 : 8),
      paddingHorizontal: s(10),
      marginHorizontal: s(3),
      backgroundColor: theme.colors.surface,
    },
    /** Matches active subcategory chip: white pill, bar-colored glyph. */
    subCategoryIconWrapper: {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.colors.surface,
      borderRadius: theme.borderRadius.md,
      paddingVertical: s(6),
      paddingHorizontal: s(10),
    },
    text: {
      fontFamily: GTFonts.semibold,
      color: theme.colors.textInverse,
      lineHeight: fs(18),
      fontSize: fs(14),
    },
    textPressed: {
      fontFamily: GTFonts.semibold,
      color: theme.colors.primaryDark,
      lineHeight: fs(18),
      fontSize: fs(14),
    },
    container: {
      flex: 1,
      justifyContent: 'center',
      backgroundColor: theme.colors.surface,
    },
    horizontal: {
      flexDirection: 'row',
      justifyContent: 'space-around',
      padding: s(8),
    },
    bottomSheet: {
      flex: 1,
      marginTop: v(15),
      alignItems: 'center',
      backgroundColor: theme.colors.surface,
    },
    bottomSheetContainer: {
      flex: 1,
      alignItems: 'center',
    },
    bottomSheetTitle: {
      fontSize: fs(24),
      lineHeight: fs(28),
      textAlign: 'center',
      fontFamily: GTFonts.bold,
      marginBottom: v(10),
      color: theme.colors.textDark,
    },
    bottomSheetinfoText: {
      marginHorizontal: s(15),
      fontSize: fs(17),
      lineHeight: fs(20),
      fontFamily: GTFonts.regular,
      textAlign: 'center',
      color: theme.colors.text,
    },
    bottomSheetButton: {
      marginBottom: v(50),
    },
    cancel: {
      position: 'absolute',
      padding: s(8),
      right: s(8),
      top: 0,
    },
    sortOptions: {
      justifyContent: 'space-around',
      padding: s(8),
    },
    productsArea: {
      flex: 1,
      flexDirection: 'row',
    },
    footerAddCardWrapper: {
      alignItems: 'center',
      marginTop: v(10),
      marginBottom: v(6),
    },
    skeletonEmpty: {
      paddingTop: v(6),
    },
    skeletonFooter: {
      paddingTop: v(10),
      paddingBottom: v(6),
    },
    addCard: {
      backgroundColor: theme.colors.surface,
      borderRadius: theme.borderRadius.md,
      borderColor: theme.colors.border,
      borderWidth: borderWidth(0.5),
      shadowColor: theme.colors.shadow,
      shadowOffset: { width: 0, height: v(0.5) },
      shadowOpacity: 0.25,
      shadowRadius: s(Platform.OS === 'web' ? 0.5 : 1),
      elevation: 2,
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: s(14),
      paddingHorizontal: s(10),
      minHeight: v(90),
      width: '100%',
    },
    addCardTitle: {
      fontFamily: GTFonts.semibold,
      color: theme.colors.text,
      fontSize: fs(14),
      lineHeight: fs(18),
    },
    addCardSubtitle: {
      fontFamily: GTFonts.regular,
      color: theme.colors.textSecondary,
      marginTop: v(2),
      fontSize: fs(12),
      lineHeight: fs(16),
    },
    pickerListContent: {
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      paddingHorizontal: s(8),
      paddingBottom: s(8),
    },
    pickerRow: {
      width: '100%',
      justifyContent: 'space-between',
      gap: s(8),
      marginBottom: v(8),
    },
    pickerRadioItem: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.background,
      borderRadius: s(8),
      paddingVertical: s(12),
      paddingHorizontal: s(10),
      borderWidth: borderWidth(Platform.OS === 'web' ? 0.5 : 1),
      borderColor: 'transparent',
      flex: 1,
      minHeight: v(isTablet() ? 56 : 64),
    },
    pickerRadioItemActive: {
      borderColor: theme.colors.success,
    },
    pickerRadioLabel: {
      marginLeft: s(6),
      color: theme.colors.text,
      fontSize: fs(14),
      lineHeight: fs(18),
    },
    pickerRadioLabelActive: {
      color: theme.colors.success,
    },
  });
